import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * status: 'checking' | 'connected' | 'error'
 */
const ConnectionBadge = ({ status }) => {
  const { t } = useTranslation();

  const config = {
    checking: {
      dotClass: 'bg-warning',
      textClass: 'text-warning',
      label: t('login.connecting', 'Connecting...'),
    },
    connected: {
      dotClass: 'bg-success',
      textClass: 'text-success',
      label: t('login.connected', 'Online'),
    },
    error: {
      dotClass: 'bg-error',
      textClass: 'text-error',
      label: t('login.disconnected', 'Offline'),
    },
  }[status];

  if (!config) return null;

  return (
    <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-card border border-border">
      <span
        className={`w-1.5 h-1.5 rounded-full ${config.dotClass} ${
          status === 'connected' ? 'animate-pulse' : ''
        }`}
      />
      <span className={`text-xs font-medium ${config.textClass}`}>{config.label}</span>
    </span>
  );
};

export default ConnectionBadge;
